/**
 * Is this browser session running on a frontline kiosk?
 *
 * The kiosk's Edge start page is `/auth/kiosk`, which sets an `isg_kiosk`
 * session cookie and then signs in (`isg-intranet` `sso_broker.kiosk_start`,
 * estate change E1). So the intranet adapts to **how somebody arrived**, not to
 * who they are.
 *
 * 🔴 NEVER A SECURITY DECISION. Anyone can set a cookie. Everything keyed off
 * this is presentation: a reminder to take the card out, a bigger Email button,
 * a settings toggle that would do nothing useful on a wiped profile. Nothing
 * here may gate data, and nothing here may be the reason something is allowed.
 *
 * ⚠️ Deliberately NOT driven by any group (Callum, 2026-09-12: *"i kinda dont
 * want people to have to be in a kiosk group, i want the system to know how
 * they are logging on and adjust accordingly"*). And since 2026-09-14 there IS
 * no kiosk group at all: who may use a kiosk is who IT has issued a card to,
 * enforced by the certificate binding in Entra. A person who holds a card sees
 * a completely ordinary intranet on their own laptop.
 *
 * ⚠️ It is a SESSION cookie, and a kiosk profile is wiped at sign-out, so it
 * cannot survive into the next person's session.
 */
const COOKIE = 'isg_kiosk';

let cached = null;

export function isKioskSession() {
  if (cached !== null) return cached;
  cached = document.cookie.split(';').some((c) => c.trim().startsWith(`${COOKIE}=1`));
  return cached;
}

/** Tests and the kiosk UI test drive this; nothing else should. */
export function _resetKioskCache() {
  cached = null;
}
